export const ZINDEX = {
  POPUP: 7000,
  HEADER: 6000,
  BELOW_HEADER_DRAWER: 5900,
  QUICK_SEARCH_OVERLAY: 6000,
  SEQUENCE_V2_STICKY_HEADER: 5100,
  SEQUENCE_V2_TEMPLATE_MENU: 5050,
  ADD_A_VARIABLE_DROPDOWN: 5000,
  EMAIL_TEMPLATE_TAG: 3000,
  SEQUENCE_LIST_SELECT_ACTIONS: 3000,
  CAMPAIGN_LIST_SELECT_ACTIONS: 3000,
  TOAST: 3000,
  BAT_TEST_POPUP: 3000,
  CAMPAIGN_ADD_TARGETS_POPUP: 3000,
  FROALA: 2500,
  PROGRESS_LINEAR: 1500,
  SEQUENCE_V2_STEP_LIST_WRAPPER: 1000,
  SCROLLER: 1000,
  TOOLTIP: 1000,
  STEP_INTERVAL_CARD_ELEMENT: 200,
  FOOTER: 200,
  SELECT_OPTIONS: 100,
  TAGS_MANAGER: 100,
  TARGET_FILTERS: 100,
  TWO: 2,
  SEQUENCE_TARGET_LIST_HEADER: 1,
  ONE: 1,
};
